export enum DurationEnum {
  YEARS = 'Y',
  MONTHS = 'M',
  WEEKS = 'W',
  DAYS = 'D',
  HOURS = 'h',
  MINUTES = 'm',
  SECONDS = 's',
}
